import React, { FC } from 'react';
import ExpandIcon from '@moda/icons/expand-16';
import CheckmarkIcon from '@moda/icons/checkmark-16';
import ExitIcon from '@moda/icons/exit-16';
import { LoadingBalls } from '../../LoadingBalls';

interface Props {
  isFollowed: boolean;
  isHovered: boolean;
  isLoading: boolean;
  withHoveringEffect: boolean;
}

const LOADING_BALLS_HEIGHT = 16;

export const DesignerChipIcon: FC<Props> = ({
  isFollowed,
  isHovered,
  isLoading,
  withHoveringEffect = true
}) => {
  if (isLoading) return <LoadingBalls height={LOADING_BALLS_HEIGHT} />;

  if (withHoveringEffect) {
    return (
      <>
        {isFollowed && (
          <>
            {isHovered && <ExitIcon />}

            {!isHovered && <CheckmarkIcon />}
          </>
        )}

        {!isFollowed && <ExpandIcon />}
      </>
    );
  }

  return (
    <>
      {isFollowed && <ExitIcon />}

      {!isFollowed && <ExpandIcon />}
    </>
  );
};
